// TODO: This file exists in KorentoClient and KorentoApi
// All actions used by store
export default {
  ACCOUNT: "account",
  EXTERNAL: "external",
  IP: "ip",
  REFERRER: "referrer",
  TICKET: "ticket",
}
